import React from 'react';
import { shape, string, element, bool, object } from 'prop-types';
import { translate } from '@airasia-common/libraries/i18n/LocaleProvider';
import PriceCTA from './PriceCTA';

const SnapPriceCTA = ({
  summary,
  baseRate,
  rightChildren,
  ctaNote = false,
  discount,
  strikethrough,
  priceBreakDownEnabled,
  data,
  isPriceBreakDownMweb,
}) => {
  const { adults = 0, children = 0, infants = 0, nights = 0 } = summary;
  const { currency, value } = baseRate;
  const guests = Number(adults) + Number(children) + Number(infants);
  return (
    <PriceCTA
      currency={currency}
      price={value}
      title={translate('tripDetails.footer.totalPrice', guests)}
      subTitle={translate('tripDetails.footer.totalNights', Number(nights))}
      rightChildren={rightChildren}
      ctaNote={ctaNote}
      discount={discount}
      strikeThrough={strikethrough}
      priceBreakDownEnabled={priceBreakDownEnabled}
      data={data}
      isPriceBreakDownMweb={isPriceBreakDownMweb}
    />
  );
};

SnapPriceCTA.propTypes = {
  summary: shape({
    adults: string,
    children: string,
    infants: string,
    nights: string,
  }).isRequired,
  baseRate: shape({
    currency: string.isRequired,
    value: string.isRequired,
  }).isRequired,
  rightChildren: element,
  ctaNote: bool,
  discount: string,
  strikethrough: object,
  priceBreakDownEnabled: bool,
  data: object,
  isPriceBreakDownMweb: bool,
};

export default SnapPriceCTA;
